<template>
  <div ref="supportActiveTickets" class="support-active-tickets-container">
    <h2>Active Tickets</h2>
    <p>Total Active Tickets</p>
    <h1>
      {{ balance }}
    </h1>
    <ButtonFilled
      @onButtonClicked="handleClick"
      text="Open a Ticket"
    ></ButtonFilled>
  </div>
</template>

<script>
import ButtonFilled from "../../common/ButtonFilled";
export default {
  components: {
    ButtonFilled,
  },
  computed: {
    balance() {
      return this.$store.getters["userStore/getBalance"];
    },
  },
  async mounted() {
    await this.sleep(10);
    this.$refs.supportActiveTickets.style = "transform: scale(1) !important";
  },
  methods: {
    handleClick() {
      // this.$router.push({ path: "/user/funds" });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
};
</script>

<style scoped>
.support-active-tickets-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 275px;
  max-width: 260px;
  height: 265px;
  width: 30%;
  max-width: 30%;
  padding: 10px;
  background: radial-gradient(100% 100% at 44.04% 0%, #26292e 0%, #1a1c1f 100%);
  box-shadow: 2px 2px 5px #000000, inset 0px 1px 3px #000000;
  border-radius: 7px;
  transform: scale(0.5);
  transition: 0.4s;
}

.support-active-tickets-container > h2 {
  font-size: 22px !important;
  font-family: "OpenSans-SemiBold";
  text-align: center;
  color: #e0e0e0;
  margin-top: 15px;
}

.support-active-tickets-container > p {
  font-size: 12px !important;
  font-family: "OpenSans";
  text-align: center;
  color: #888888;
  margin-top: 5px;
}

.support-active-tickets-container > h1 {
  font-size: 42px !important;
  font-family: "OpenSans-SemiBold";
  text-align: center;
  color: #ffffff;
  margin-top: 46px;
  margin-bottom: 20px;
}
.support-active-tickets-container > h1 > span {
  color: #888888;
  font-size: 12px;
  font-family: "OpenSans";
}
</style>
